import { useEffect, useState } from "react";
import axios from "axios";
import Logo from "./Logo";
import { scrollToId } from "@/lib/scroll";
import { ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const links = [
  { label: "Problem", href: "#problem", testid: "nav-problem" },
  { label: "How It Works", href: "#how", testid: "nav-how" },
  { label: "Features", href: "#features", testid: "nav-features" },
  { label: "Pricing", href: "#pricing", testid: "nav-pricing" },
  { label: "FAQ", href: "#faq", testid: "nav-faq" },
];

export default function Header() {
  const [jobsSaved, setJobsSaved] = useState(2410);

  useEffect(() => {
    axios
      .get(`${API}/stats`)
      .then((r) => setJobsSaved(r.data.jobs_saved_this_week))
      .catch(() => {});
  }, []);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/[0.08] bg-[#0B0D10]/75 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <a
          href="/"
          data-testid="nav-home-link"
          className="flex items-center gap-2.5"
        >
          <Logo size={32} />
          <span className="font-display text-lg font-bold tracking-tight text-slate-50">
            Backfill
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              onClick={(e) => {
                e.preventDefault();
                scrollToId(l.href);
              }}
              className="text-sm font-medium text-slate-400 transition-colors duration-200 hover:text-slate-50"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <div
            data-testid="jobs-saved-badge"
            className="hidden items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.03] px-3.5 py-1.5 xl:flex"
          >
            <span className="relative flex h-2 w-2">
              <span className="ping-slow absolute inline-flex h-full w-full rounded-full bg-emerald-400" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
            </span>
            <span
              data-testid="jobs-saved-count"
              className="font-mono text-[11px] uppercase tracking-wider text-slate-300"
            >
              {jobsSaved.toLocaleString()} jobs saved this week
            </span>
          </div>
          <a
            href="/portal"
            data-testid="nav-login-cta"
            className="rounded-md border border-white/[0.12] px-4 py-2 text-sm font-semibold text-slate-300 transition-colors duration-200 hover:border-[#F25F22]/50 hover:text-slate-50"
          >
            Login
          </a>
          <a
            href="/signup"
            data-testid="nav-signup-cta"
            className="group flex items-center gap-1.5 rounded-md bg-[#F25F22] px-4 py-2 text-sm font-semibold text-white transition-all duration-200 hover:bg-[#FF7539] hover:shadow-[0_0_24px_rgba(242,95,34,0.45)]"
          >
            Start Now
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
          </a>
        </div>
      </div>
    </header>
  );
}
